export const uiState = {
    currentPage: "demirbas",
    currentUser: null, // { id, email, yetki, adSoyad, initials }

    demirbas: {
        searchMode: "filtre",
        barcodeQuery: "",
        filters: {
            departman_id: "",
            departman_urun_grubu_id: "",
            urun_grubu_urun_alt_grubu_id: "",
            urun_alt_grubu_urun_cinsi_id: "",
            urun_cinsi_marka_id: "",
            marka_model_id: "",
            fatura_no: "",
            tarih_baslangic: "",
            tarih_bitis: "",
            satin_alma_min: "",
            satin_alma_max: "",
            urun_durumu_id: "",
            zimmet_durumu_id: "",
            zimmetlenen_tc: "",
            lokasyon_id: "",
            lokasyon_oda_id: "",
            oda_yer_id: "",
        },

        lastSearchUrl: null,
        paginationLimit: 10,

        visibleColumns: [],
        selectedDemirbasId: null,
        cart: [],
    },

    kisiler: {
        filters: { departman_id: "", unvan_id: "", tc: "", ad: "", soyad: "", durum: "" },
        lastSearchUrl: null,
        paginationLimit: 10,
    },
    "tablo-tanimlar": { activeCategory: null },
    "urun-agaci-yonetimi": {
        departman_id: "",
        departman_urun_grubu_id: "",
        urun_grubu_urun_alt_grubu_id: "",
        urun_alt_grubu_urun_cinsi_id: "",
        urun_cinsi_marka_id: "",
    },
	amortisman: {
		paginationLimit: 25,
		filters: {
			arama: "",
			durum: "actionable",
			tanim_id: "",
			bitis_baslangic: "",
			bitis_bitis: "",
		},
	},
    uyelikler: {
        filters: { yetki_id: "", durum: "", ad: "", soyad: "", tc: "" },
        lastSearchUrl: null,
        paginationLimit: 10,
    },
    log: {
        paginationLimit: 10,
        offset: 0,
        lastSearchUrl: null,
        filters: { modul: "", islem: "", yapan_tc: "", tarih_baslangic: "", tarih_bitis: "" },
    },
};
